/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './external-demand-source-list-page.component.html';

import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {
  ExternalDemandSourceApiService,
  ExternalDemandSourceModel
} from './external-demand-source-api.service';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-external-demand-source-list-page',
  template
})
export class ExternalDemandSourceListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.external-demand-sources.external-demand-source';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'externalPartner'},
    {param: 'publisherId'},
    {param: 'apiKey'}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<ExternalDemandSourceModel>(
    inject(ExternalDemandSourceApiService),
    {listId: 'fullExternalDemandSourceList', baseTable: 'externalDemandSource'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
